
export default {
    addError (validator, options, key, errorKey) {
        var _key = validator.dictionary.getAttribute(validator.locale, key);

        console.error('Attempting to add error: ' + errorKey + ' to field: ' + _key + '(' + key + ') in language: ' +validator.locale)

        const field = validator.fields.find({ name: key, scope: options.scope });
                  
        if (!field) return;

        var message = validator.dictionary.getMessage(validator.locale, errorKey, [ _key ]);

        validator.errors.add({
            id: field.id,
            field: key,
            msg: message,
            scope: options.scope,
        });

        field.setFlags({
            invalid: true,
            valid: false,
            validated: true,
        });
    },
    parseErrors(validator, options, err){
        if( err.response === undefined )
            return;
        
        if( err.response.data === undefined )
            return;

        var data = err.response.data;

        if(data.Errors !== undefined){
            for(var i = 0; i < data.Errors.length; i++){
                this.addError(validator, options, data.Errors[i].Parameter.toLowerCase(), data.Errors[i].ErrorKey);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./WebApp/utils/errorParser.js